import assignToThis from "../../helper/assignToThis";
import { GridComplexPricePeriod } from "@/dto/scenario/eco/GridComplexPricePeriod";
import { ObjectOnly } from '@/classes/ObjectOnly';

export class GridComplexPricing {

    public prices: number[] | null = null;

    public isCharge: boolean[] | null = null;

    public periods: GridComplexPricePeriod[] | null = null;

    public constructor(obj: ObjectOnly = {}) {
        assignToThis(this, obj);

        this.periods = this.periods ? this.periods.map(p => new GridComplexPricePeriod(p)) : null;
    }

}
